export const RIISE_SOURCE = 'riise';
export const CLASSMED_SOURCE = 'classmed';
export const CLASSMED_HOST = 'classmed.weriise.co';
export const CLASSMED_RESULT_STORAGE_KEY = 'classmedQuizResult';
export const CLASSMED_ID_STORAGE_KEY = 'classmedId';
export const CLASSMED_PHARMACY_ID_STORAGE_KEY = 'classmedPharmacyId';

export const isClassmedHost = (hostname = window.location.hostname) =>
  hostname === CLASSMED_HOST || hostname.startsWith('classmed.');

export const isClassmedPath = (pathname = window.location.pathname) =>
  pathname === '/classmed' || pathname.startsWith('/classmed/');

export const isClassmedMode = ({ hostname = window.location.hostname, pathname = window.location.pathname } = {}) =>
  isClassmedHost(hostname) || isClassmedPath(pathname);

export const getClassmedIdFromSearch = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return String(params.get('classmed_id') || '').trim();
};

export const getClassmedPharmacyIdFromSearch = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return String(params.get('pharmacy_id') || '').trim();
};

export const isClassmedRetakeFromSearch = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return params.get('retake') === '1';
};

export const saveClassmedId = (classmedId) => {
  if (typeof window === 'undefined') return;
  const normalizedClassmedId = String(classmedId || '').trim();
  if (!normalizedClassmedId) return;
  localStorage.setItem(CLASSMED_ID_STORAGE_KEY, normalizedClassmedId);
};

export const getStoredClassmedId = () => {
  if (typeof window === 'undefined') return '';
  return String(localStorage.getItem(CLASSMED_ID_STORAGE_KEY) || '').trim();
};

export const saveClassmedPharmacyId = (pharmacyId) => {
  if (typeof window === 'undefined') return;
  const normalizedPharmacyId = String(pharmacyId || '').trim();
  if (!normalizedPharmacyId) return;
  localStorage.setItem(CLASSMED_PHARMACY_ID_STORAGE_KEY, normalizedPharmacyId);
};

export const getStoredClassmedPharmacyId = () => {
  if (typeof window === 'undefined') return '';
  return String(localStorage.getItem(CLASSMED_PHARMACY_ID_STORAGE_KEY) || '').trim();
};

export const buildClassmedQuery = (classmedId, options = {}) => {
  const params = new URLSearchParams();
  if (classmedId) params.set('classmed_id', classmedId);
  if (options.pharmacyId) params.set('pharmacy_id', options.pharmacyId);
  if (options.retake) params.set('retake', '1');
  return params.toString();
};

export const getClassmedQuizPath = (classmedId, options = {}) => {
  const query = buildClassmedQuery(classmedId, options);
  return query ? `/classmed/quiz?${query}` : '/classmed/quiz';
};

export const getClassmedResultPath = (classmedId, options = {}) => {
  const query = buildClassmedQuery(classmedId, options);
  return query ? `/classmed/result?${query}` : '/classmed/result';
};

export const saveClassmedResult = (result, classmedId = '', lang = 'fr') => {
  if (typeof window === 'undefined') return null;
  saveClassmedId(classmedId || result?.classmedUser?.classmedId);
  const resultWithLang = {
    ...result,
    classmedResultLang: lang,
  };
  sessionStorage.setItem(CLASSMED_RESULT_STORAGE_KEY, JSON.stringify(resultWithLang));
  return resultWithLang;
};

export const getStoredClassmedResult = () => {
  if (typeof window === 'undefined') return null;

  try {
    const result = sessionStorage.getItem(CLASSMED_RESULT_STORAGE_KEY);
    return result ? JSON.parse(result) : null;
  } catch (error) {
    sessionStorage.removeItem(CLASSMED_RESULT_STORAGE_KEY);
    return null;
  }
};
